"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[652],{

/***/ 90652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es_Pagination; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/classNames.js
var _util_classNames = __webpack_require__(34855);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconLeft/index.js
var IconLeft = __webpack_require__(42355);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconRight/index.js
var IconRight = __webpack_require__(826);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconMore/index.js
var IconMore = __webpack_require__(47962);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/ConfigProvider/index.js + 1 modules
var ConfigProvider = __webpack_require__(32393);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useKeyboardEvent.js
var useKeyboardEvent = __webpack_require__(57483);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Pagination/page-item.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};







var StepType;
(function (StepType) {
    StepType[StepType["previous"] = 0] = "previous";
    StepType[StepType["next"] = 1] = "next";
})(StepType || (StepType = {}));
/**
 * default pager item
 */
function Pager(props) {
    var _a;
    var locale = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_).locale;
    var getKeyboardEvents = (0,useKeyboardEvent/* default */.Z)();
    var pageNum = props.pageNum, current = props.current, rootPrefixCls = props.rootPrefixCls, pageItemStyle = props.pageItemStyle, activePageItemStyle = props.activePageItemStyle, itemRender = props.itemRender;
    var prefixCls = rootPrefixCls + "-item";
    var isActive = current === pageNum;
    var classnames = (0,_util_classNames/* default */.Z)(prefixCls, isActive ? prefixCls + "-active" : '');
    var style = pageItemStyle;
    if (isActive) {
        style = __assign(__assign({}, style), activePageItemStyle);
    }
    var ariaCurrentProps = isActive ? { 'aria-current': true } : {};
    var onClick = function (e) {
        var pageNum = props.pageNum, onClick = props.onClick, disabled = props.disabled;
        if (e.currentTarget.dataset.active === 'true') {
            return;
        }
        e.stopPropagation();
        if (!disabled) {
            onClick && onClick(pageNum);
        }
    };
    return (react.createElement("li", __assign({ style: style, className: classnames, onClick: onClick, tabIndex: props.disabled ? -1 : 0, "aria-label": (_a = locale.Pagination.currentPage) === null || _a === void 0 ? void 0 : _a.replace('{0}', pageNum) }, getKeyboardEvents({ onPressEnter: onClick }), ariaCurrentProps), itemRender ? itemRender(pageNum, 'page', pageNum) : pageNum));
}
function getIcon(name, icons) {
    switch (name) {
        case 'prev':
            return icons && icons.prev ? icons.prev : react.createElement(IconLeft/* default */.Z, null);
        case 'next':
            return icons && icons.next ? icons.next : react.createElement(IconRight/* default */.Z, null);
        case 'more':
            return icons && icons.more ? icons.more : react.createElement(IconMore/* default */.Z, null);
        default:
            return null;
    }
}
/**
 * preJump or nextJump button
 * @param props
 */
var JumpPager = function (props) {
    var _a, _b;
    var locale = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_).locale;
    var rootPrefixCls = props.rootPrefixCls, current = props.current, allPages = props.allPages, jumpPage = props.jumpPage, icons = props.icons, disabled = props.disabled, pageItemStyle = props.pageItemStyle, itemRender = props.itemRender;
    var minCurrent = allPages > 0 ? 1 : 0;
    var nextPage = Math.min(allPages, Math.max(minCurrent, current + jumpPage));
    var prefix = rootPrefixCls + "-item " + rootPrefixCls + "-item-jumper";
    var cls = (0,_util_classNames/* default */.Z)(prefix);
    var onClick = function () {
        !disabled && props.onClick && props.onClick(nextPage);
    };
    var originElement = getIcon('more', icons);
    var ariaLabel = jumpPage > 0
        ? (_a = locale.Pagination.nextSomePages) === null || _a === void 0 ? void 0 : _a.replace('{0}', jumpPage)
        : (_b = locale.Pagination.prevSomePages) === null || _b === void 0 ? void 0 : _b.replace('{0}', -jumpPage);
    return (react.createElement("li", { style: pageItemStyle, className: cls, onClick: onClick, "aria-label": ariaLabel }, itemRender ? itemRender(undefined, 'more', originElement) : originElement));
};
/**
 * previous or next button
 * @param props
 */
var StepPager = function (props) {
    var _a;
    var _b = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_), locale = _b.locale, rtl = _b.rtl;
    var getKeyboardEvents = (0,useKeyboardEvent/* default */.Z)();
    var rootPrefixCls = props.rootPrefixCls, current = props.current, allPages = props.allPages, type = props.type, icons = props.icons, disabled = props.disabled, pageItemStyle = props.pageItemStyle, itemRender = props.itemRender;
    var prefixCls = rootPrefixCls + "-item";
    var _c = __read(rtl ? ['next', 'prev'] : ['prev', 'next'], 2), prev = _c[0], next = _c[1];
    var StepIcon = type === StepType.previous ? getIcon(prev, icons) : getIcon(next, icons);
    var _disabled = false;
    if (allPages === 0) {
        // total为0
        _disabled = true;
    }
    else if (type === StepType.previous) {
        // 向前翻页
        _disabled = current <= 1; // current ===0 || current===1
    }
    else {
        // 向后翻页
        _disabled = current === allPages;
    }
    var innerDisabled = disabled || _disabled;
    var nextPage = current + (type === StepType.previous ? -1 : 1);
    nextPage = Math.max(0, Math.min(allPages, nextPage));
    var pageType = StepType.previous === type ? 'prev' : 'next';
    var cls = (0,_util_classNames/* default */.Z)(prefixCls, prefixCls + "-" + pageType, (_a = {},
        _a[prefixCls + "-disabled"] = innerDisabled,
        _a));
    var onClick = function () {
        if (innerDisabled) {
            return;
        }
        props.onClick && props.onClick(nextPage);
    };
    return (react.createElement("li", __assign({ style: pageItemStyle, className: cls, onClick: onClick, tabIndex: innerDisabled ? -1 : 0, "aria-label": locale.Pagination[pageType] }, getKeyboardEvents({
        onPressEnter: onClick,
    })), itemRender ? itemRender(undefined, pageType, StepIcon) : StepIcon));
};
/* harmony default export */ var page_item = (Pager);

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useMergeValue.js
var useMergeValue = __webpack_require__(15955);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Select/index.js
var Select = __webpack_require__(94558);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Pagination/page-options.js
var page_options_assign = (undefined && undefined.__assign) || function () {
    page_options_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return page_options_assign.apply(this, arguments);
};



var noop = function () { };
var Option = Select/* default.Option */.Z.Option;
var _SizeOptions = [10, 20, 30, 40, 50];
function PageOption(props) {
    var selectRef = (0,react.useRef)();
    var locale = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_).locale;
    var _a = props.sizeCanChange, sizeCanChange = _a === void 0 ? false : _a, _b = props.onPageSizeChange, onPageSizeChange = _b === void 0 ? noop : _b, rootPrefixCls = props.rootPrefixCls, _c = props.sizeOptions, sizeOptions = _c === void 0 ? _SizeOptions : _c, _d = props.pageSize, pageSize = _d === void 0 ? 10 : _d, size = props.size, selectProps = props.selectProps, disabled = props.disabled;
    return (sizeCanChange && (react.createElement("div", { ref: selectRef, className: rootPrefixCls + "-option", "aria-label": locale.Pagination.pageSize },
        react.createElement(Select/* default */.Z, page_options_assign({ value: sizeOptions.indexOf(pageSize) !== -1 ? pageSize : sizeOptions[0], onChange: function (value) {
                onPageSizeChange(value);
            }, size: size, getPopupContainer: function () { return selectRef.current; }, disabled: disabled }, selectProps), sizeOptions.map(function (num) {
            return (react.createElement(Option, { key: num, value: num }, num + " " + locale.Pagination.countPerPage));
        })))));
}
/* harmony default export */ var page_options = (PageOption);

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Input/index.js + 6 modules
var Input = __webpack_require__(1393);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/is.js
var is = __webpack_require__(53367);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Pagination/page-jumper.js
var page_jumper_assign = (undefined && undefined.__assign) || function () {
    page_jumper_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return page_jumper_assign.apply(this, arguments);
};
var page_jumper_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};




function PageJumper(props) {
    var defaultInputText = props.simple ? props.current : undefined;
    var locale = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_).locale;
    var _a = page_jumper_read((0,react.useState)(defaultInputText), 2), inputText = _a[0], setInputText = _a[1];
    var inputRef = (0,react.useRef)();
    (0,react.useEffect)(function () {
        if (props.simple) {
            setInputText(props.current);
        }
    }, [props.simple, props.current]);
    var handleChange = function (val) {
        var value = parseInt(val, 10);
        setInputText(isNaN(value) ? undefined : value);
    };
    var handleJump = function () {
        var onPageChange = props.onPageChange, totalPages = props.totalPages, current = props.current, simple = props.simple;
        if ((0,is/* isUndefined */.o8)(inputText)) {
            return;
        }
        if (inputText === current) {
            if (!simple) {
                setInputText(undefined);
            }
            return;
        }
        var page = isNaN(Number(inputText)) ? current : Number(inputText);
        if (page < 1) {
            page = 1;
        }
        else if (page > totalPages) {
            page = totalPages;
        }
        setInputText(simple ? page : undefined);
        (0,is/* isFunction */.mf)(onPageChange) && onPageChange(page);
    };
    var onFocus = function () {
        var input = inputRef.current.dom;
        if (String(inputText) && input) {
            input.setSelectionRange(0, String(inputText).length);
        }
    };
    var rootPrefixCls = props.rootPrefixCls, totalPages = props.totalPages, simple = props.simple, size = props.size, disabled = props.disabled;
    var prefixCls = rootPrefixCls + "-jumper";
    var inputConfig = page_jumper_assign({ showJumper: true }, ((0,is/* isObject */.Kn)(simple) ? simple : {}));
    return (react.createElement("div", { className: "" + prefixCls },
        !simple && react.createElement("span", { className: prefixCls + "-text-goto" }, locale.Pagination.goto),
        inputConfig.showJumper ? (react.createElement(Input/* default */.Z, { _ignorePropsFromGlobal: true, ref: function (ref) { return (inputRef.current = ref); }, className: prefixCls + "-input", value: !(0,is/* isUndefined */.o8)(inputText) ? inputText.toString() : undefined, size: size, disabled: disabled || !totalPages, onChange: handleChange, onPressEnter: handleJump, onFocus: onFocus, onBlur: handleJump })) : (react.createElement("span", null, inputText)),
        !simple && react.createElement("span", { className: prefixCls + "-text-goto-suffix" }, locale.Pagination.page),
        simple && (react.createElement(react.Fragment, null,
            react.createElement("span", { className: prefixCls + "-separator" }, "/"),
            react.createElement("span", null, totalPages)))));
}
/* harmony default export */ var page_jumper = (PageJumper);

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useMergeProps.js
var useMergeProps = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/pick.js
var pick = __webpack_require__(9472);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Pagination/pagination.js
var pagination_assign = (undefined && undefined.__assign) || function () {
    pagination_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return pagination_assign.apply(this, arguments);
};
var pagination_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};









var _defaultCurrent = 1;
var _defaultPageSize = 10;
function getAllPages(pageSize, total) {
    if (pageSize === void 0) { pageSize = _defaultPageSize; }
    return Math.ceil(total / pageSize);
}
function getBufferSize(bufferSize, allPages) {
    var min = 0;
    var max = Math.floor(allPages / 2) - 1;
    var newBufferSize = Math.max(bufferSize, min);
    return Math.min(newBufferSize, max);
}
function getAdjustPageSize(sizeOptions) {
    if (sizeOptions && sizeOptions.length) {
        return sizeOptions[0];
    }
    return _defaultPageSize;
}
var defaultProps = {
    total: 0,
    pageSizeChangeResetCurrent: true,
    bufferSize: 2,
};
function Pagination(baseProps, ref) {
    var _a;
    var _b;
    var _c = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_), getPrefixCls = _c.getPrefixCls, ctxSize = _c.size, locale = _c.locale, componentConfig = _c.componentConfig, rtl = _c.rtl;
    var props = (0,useMergeProps/* default */.Z)(baseProps, defaultProps, componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.Pagination);
    var propTotal = props.total, propPageSize = props.pageSize, propCurrent = props.current, propShowMore = props.showMore, propSizeOptions = props.sizeOptions, pageSizeChangeResetCurrent = props.pageSizeChangeResetCurrent, defaultCurrent = props.defaultCurrent, defaultPageSize = props.defaultPageSize;
    var _d = pagination_read((0,useMergeValue/* default */.Z)(_defaultCurrent, {
        defaultValue: defaultCurrent,
        value: propCurrent,
    }), 2), current = _d[0], setCurrent = _d[1];
    var _e = pagination_read((0,useMergeValue/* default */.Z)(getAdjustPageSize(propSizeOptions), {
        defaultValue: defaultPageSize,
        value: propPageSize,
    }), 2), pageSize = _e[0], setPageSize = _e[1];
    var total = propTotal;
    var showMore = !!propShowMore;
    if (propCurrent && !props.onChange) {
        console.warn('Warning: you have provide current prop for pagination but without onChange handler ,' +
            ' this will cause no-change when you change page. ');
    }
    function getAdjustedCurrent(newPageSize, newTotal) {
        var newAllPages = getAllPages(newPageSize, newTotal);
        var newCurrent = current > newAllPages ? newAllPages : current;
        return newCurrent;
    }
    (0,react.useEffect)(function () {
        // adjust pageSize after sizeOption changes
        var needAdjust = propSizeOptions && !propSizeOptions.includes(pageSize);
        // trigged when currentPageSize not in the options;
        if (needAdjust) {
            var adjustPageSize = getAdjustPageSize(propSizeOptions);
            if (!('pageSize' in props)) {
                setPageSize(adjustPageSize);
            }
        }
    }, [propSizeOptions]);
    (0,react.useEffect)(function () {
        // adjust currentPage after total and pageSize changes
        var newCurrent = getAdjustedCurrent(pageSize, total);
        if (newCurrent !== current && !('current' in props)) {
            setCurrent(newCurrent);
        }
    }, [total, current, pageSize]);
    var onChange = function (pageNumber, size) {
        if (pageNumber === void 0) { pageNumber = current; }
        if (size === void 0) { size = pageSize; }
        var onChange = props.onChange;
        onChange && onChange(pageNumber, size);
    };
    var onPageSizeChange = function (pageSize) {
        var onPageSizeChange = props.onPageSizeChange;
        var allPages = getAllPages(pageSize, total);
        var newState = {
            pageSize: pageSize,
        };
        if (pageSizeChangeResetCurrent) {
            newState.current = 1;
        }
        else {
            newState.current = current > allPages ? allPages : current;
        }
        if (!('pageSize' in props)) {
            setPageSize(newState.pageSize);
        }
        if (!('current' in props) && current !== newState.current) {
            setCurrent(newState.current);
        }
        onPageSizeChange && onPageSizeChange(pageSize, newState.current);
        onChange(pageSizeChangeResetCurrent ? 1 : newState.current, pageSize);
    };
    var onPageNumberChange = function (pageNumber) {
        if (!('current' in props)) {
            setCurrent(pageNumber);
        }
        onChange(pageNumber);
    };
    var className = props.className, style = props.style, pageItemStyle = props.pageItemStyle, activePageItemStyle = props.activePageItemStyle, showTotal = props.showTotal, sizeCanChange = props.sizeCanChange, sizeOptions = props.sizeOptions, simple = props.simple, mini = props.mini, showJumper = props.showJumper, selectProps = props.selectProps, icons = props.icons, disabled = props.disabled, itemRender = props.itemRender, hideOnSinglePage = props.hideOnSinglePage;
    var size = props.size || ctxSize;
    var prefixCls = getPrefixCls('pagination');
    // compatible 1.0
    var innerSize = mini ? 'mini' : size;
    var classNames = (0,_util_classNames/* default */.Z)(prefixCls, prefixCls + "-size-" + innerSize, (_a = {},
        _a[prefixCls + "-simple"] = simple,
        _a[prefixCls + "-disabled"] = disabled,
        _a[prefixCls + "-rtl"] = rtl,
        _a), className);
    var renderPager;
    var pageList = [];
    var allPages = getAllPages(pageSize, total);
    var bufferSize = getBufferSize(props.bufferSize, allPages);
    if (hideOnSinglePage && allPages <= 1) {
        return null;
    }
    var pagerProps = {
        onClick: onPageNumberChange,
        rootPrefixCls: prefixCls,
        simple: simple,
        current: current,
        allPages: allPages,
        icons: icons,
        disabled: disabled,
        pageItemStyle: pageItemStyle,
        activePageItemStyle: activePageItemStyle,
        itemRender: itemRender,
    };
    // simple mode, no pager list
    if (simple) {
        var prefix = prefixCls + "-item-simple";
        renderPager = (react.createElement("ul", { className: prefixCls + "-list" },
            react.createElement(StepPager, pagination_assign({ key: "previous" }, pagerProps, { type: StepType.previous })),
            react.createElement("li", { className: prefix + "-pager" },
                react.createElement(page_jumper, { disabled: disabled, rootPrefixCls: prefixCls, totalPages: allPages, current: current, onPageChange: onPageNumberChange, simple: { showJumper: typeof showJumper === 'boolean' ? showJumper : true }, size: innerSize })),
            react.createElement(StepPager, pagination_assign({ key: "next" }, pagerProps, { type: StepType.next }))));
    }
    else {
        // fold = ... >= 2pages;
        var beginFoldPage = 1 + 2 + bufferSize;
        var endFoldPage = allPages - 2 - bufferSize;
        if (
        // beginPage(1 page) + bufferSize * 2 + endPage(1 page) + ...(2 pages)
        allPages <= 4 + bufferSize * 2 ||
            (current === beginFoldPage && current === endFoldPage)) {
            for (var i = 1; i <= allPages; i++) {
                pageList.push(react.createElement(page_item, pagination_assign({}, pagerProps, { key: i, pageNum: i })));
            }
        }
        else {
            var left = 1;
            var right = allPages;
            var hasJumpPre = true;
            var hasJumpNext = true;
            // fold front and back
            if (current > beginFoldPage && current < endFoldPage) {
                right = current + bufferSize;
                left = current - bufferSize;
                // fold back
            }
            else if (current <= beginFoldPage) {
                hasJumpPre = false;
                left = 1;
                right = Math.max(beginFoldPage, bufferSize + current);
                // fold begin
            }
            else if (current >= endFoldPage) {
                hasJumpNext = false;
                right = allPages;
                left = Math.min(endFoldPage, current - bufferSize);
            }
            for (var i = left; i <= right; i++) {
                pageList.push(react.createElement(page_item, pagination_assign({ key: i, pageNum: i }, pagerProps)));
            }
            var JumpPre = (react.createElement(JumpPager, pagination_assign({}, pagerProps, { key: left - 1, type: StepType.previous, jumpPage: -(bufferSize * 2 + 1) })));
            var JumpNext = (react.createElement(JumpPager, pagination_assign({}, pagerProps, { key: right + 1, type: StepType.next, jumpPage: bufferSize * 2 + 1 })));
            var FirstPager = react.createElement(page_item, pagination_assign({ key: 1, pageNum: 1 }, pagerProps));
            var LastPager = react.createElement(page_item, pagination_assign({}, pagerProps, { key: allPages, pageNum: allPages }));
            if (hasJumpPre) {
                pageList[0] = react.cloneElement(pageList[0], {
                    className: prefixCls + "-item-after-pre",
                });
                // TODO:
                pageList.unshift(JumpPre);
                pageList.unshift(FirstPager);
            }
            if (hasJumpNext) {
                pageList[pageList.length - 1] = react.cloneElement(pageList[pageList.length - 1], {
                    className: prefixCls + "-item-before-next",
                });
                pageList.push(JumpNext);
                pageList.push(LastPager);
            }
        }
        renderPager = (react.createElement("ul", { className: prefixCls + "-list" },
            react.createElement(StepPager, pagination_assign({}, pagerProps, { key: "previous", type: StepType.previous })),
            pageList,
            showMore && (react.createElement(JumpPager, pagination_assign({}, pagerProps, { key: allPages + 1, type: StepType.next, jumpPage: bufferSize * 2 + 1 }))),
            react.createElement(StepPager, pagination_assign({ key: "next" }, pagerProps, { type: StepType.next }))));
    }
    var totalElement = null;
    if (typeof showTotal === 'boolean' && showTotal) {
        totalElement = (react.createElement("div", { className: prefixCls + "-total-text" }, (_b = locale.Pagination.total) === null || _b === void 0 ? void 0 : _b.replace('{0}', total)));
    }
    if (typeof showTotal === 'function') {
        totalElement = (react.createElement("div", { className: prefixCls + "-total-text" }, showTotal(total, [(current - 1) * pageSize + 1, current * pageSize])));
    }
    return (react.createElement("div", pagination_assign({}, (0,pick/* pickDataAttributes */.m)(props), { className: classNames, style: style, ref: ref }),
        totalElement,
        renderPager,
        react.createElement(page_options, { disabled: disabled, rootPrefixCls: prefixCls, sizeCanChange: sizeCanChange, sizeOptions: sizeOptions, onPageSizeChange: onPageSizeChange, pageSize: pageSize, size: innerSize, selectProps: selectProps }),
        !simple && showJumper && (react.createElement(page_jumper, { disabled: disabled, rootPrefixCls: prefixCls, totalPages: allPages, current: current, onPageChange: onPageNumberChange, size: innerSize }))));
}
var PaginationComponent = (0,react.forwardRef)(Pagination);
PaginationComponent.displayName = 'Pagination';
/* harmony default export */ var pagination = (PaginationComponent);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Pagination/index.js

/* harmony default export */ var es_Pagination = (pagination);


/***/ })

}]);